import { render, staticRenderFns } from "./Colecoes.vue?vue&type=template&id=cdb6c624&scoped=true"
import script from "./Colecoes.vue?vue&type=script&lang=js"
export * from "./Colecoes.vue?vue&type=script&lang=js"
import style0 from "./Colecoes.vue?vue&type=style&index=0&id=cdb6c624&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdb6c624",
  null
  
)

export default component.exports